import { render, staticRenderFns } from "./UserViewPage.vue?vue&type=template&id=78170f3e&"
import script from "./UserViewPage.vue?vue&type=script&lang=js&"
export * from "./UserViewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports